module.exports = __webpack_public_path__ + "img/icon_map_huanjingjiankong_lixian_dianji.6694cbce.svg";